import Http from 'utils/http'
import * as types from '../mutation-types'

export const all = ({ dispatch }, site, include = []) => {
	return Http.include(include).get(`sites/${site}/tank-groups`).then(response => {
		dispatch(types.SET_TANK_GROUPS, response.body.data);

		return response;
	});
}

export const store = ({ dispatch }, site, name) => {
	return Http.post(`sites/${site}/tank-groups`, { name }).then(response => {
		dispatch(types.ADD_TANK_GROUP, response.body.data);
		dispatch(types.SET_ACTIVE_TANK_GROUP, response.body.data);

		return response;
	});
}

export const update = ({ dispatch }, site, tankGroup) => {
	return Http.put(`sites/${site}/tank-groups/${tankGroup.id}`, { name: tankGroup.name }).then(response => {
		dispatch(types.SET_TANK_GROUP_NAME, tankGroup.id, response.body.data.name);

		return response;
	});
}

export const edit = ({ dispatch }, tankGroup) => {
	dispatch(types.SET_ACTIVE_TANK_GROUP, tankGroup);
}

export const clear = ({ dispatch }) => {
	dispatch(types.SET_ACTIVE_TANK_GROUP, {});
}

export const destroy = ({ dispatch }, site, id) => {
	return Http.destroy(`sites/${site}/tank-groups/${id}`).then(response => {
		dispatch(types.DESTROY_TANK_GROUP, id);
	});
}

export const reposition = ({ dispatch }, site, hierarchy, include = []) => {
	return Http.include(include).post(`sites/${site}/tank-groups/reposition`, { hierarchy }).then(response => {
		dispatch(types.SET_TANK_GROUPS, response.body.data);

		return response;
	});
}



// WEBPACK FOOTER //
// ./src/vuex/actions/tank-groups.js